import axios from 'axios';

const ImportDocumentService = {
  async getImportDocument(id) {
    const response = await axios.get(`/import_document/${id}`);

    return response.data;
  },

  async createImportDocument({ documentId, importId }) {
    const response = await axios.post(`/import_document`, {
      document_id: documentId,
      import_id: importId,
    });

    return response.data;
  },

  async importDocument({
    importDocumentId,
    borrowerId,
    coborrowerId,
    changes,
  }) {
    const response = await axios.post(
      `/import_document/${importDocumentId}/import`,
      {
        import_document_id: importDocumentId,
        borrower_id: borrowerId,
        coborrower_id: coborrowerId,
        changes,
      }
    );

    return response.data;
  },
};

export default ImportDocumentService;
